export default __webpack_public_path__ + "static/media/info.8a1bec42.svg";